import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "tagsList",
    "tagsValidationInput",
    "commentsInput",
    "commentsRequiredMark",
    "logoAlreadyExistsCheckbox",
    "logoImageInput",
    "logoImageRequiredMark"
  ];

  connect() {
    $("input[type=checkbox]", this.tagsListTarget).on("change", () => {
      if (!this.logoAlreadyExistsCheckboxTarget.checked) {
        this.resetTagsValidationInput();
      }
    });

    $(this.logoAlreadyExistsCheckboxTarget).on("change", () => {
      if (this.logoAlreadyExistsCheckboxTarget.checked) {
        $(this.commentsRequiredMarkTarget).show();
        this.commentsInputTarget.required = true;
        this.logoImageInputTarget.required = false;
        this.logoImageInputTarget.setCustomValidity('');
        $(this.logoImageRequiredMarkTarget).hide();

        $(this.tagsValidationInputTarget).val("valid");
        $(this.tagsValidationInputTarget).trigger("change");
      } else {
        $(this.commentsRequiredMarkTarget).hide();
        this.commentsInputTarget.required = false;
        this.logoImageInputTarget.required = true;
        $(this.logoImageRequiredMarkTarget).show();
        this.resetTagsValidationInput();
      }
    });
  }

  resetTagsValidationInput() {
    const $tagsValidationInput = $(this.tagsValidationInputTarget);

    $tagsValidationInput.val(
      $("input[type=checkbox]:checked", this.tagsListTarget).length
        ? "valid"
        : "",
    );
    $tagsValidationInput.trigger("change");
  }
}
